const reducer = (state, action) => ({
  ...state,
  proposedSlot: action.slot,
});

export default reducer;
